/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const EmptyBranchHelpText = styled.div({
  marginBottom: '10px',
  marginTop: '10px',
});
